import Grid from '@mui/material/Grid';


import Rosuvastatin from "./Rosuvastatin/Rosuvastatin";
import Dia_rosuvastatin from "./Rosuvastatin/Dia_rosuvastatin";

import Statin from "./Statins/Statin";
import Dia_statin from "./Statins/Dia_statin";

import Phenytoin from "./Phenytoin/Phenytoin";
import Dia_phenytoin from "./Phenytoin/Dia_phenytoin";

import Abacavir from "./Abacavir/Abacavir"
import Dia_abacavir from "./Abacavir/Dia_abacavir"

import Allopurinol from "./Allopurinol/Allopurinol";
import Dia_allopurinol from "./Allopurinol/Dia_allopurinol";

import Amitriptyline from "./Amitriptyline/Amitriptyline";
import Dia_amitriptyline from "./Amitriptyline/Dia_amitriptyline";

import Aripiprazole from "./Aripiprazole/Aripiprazole";
import Dia_aripiprazole from "./Aripiprazole/Dia_aripiprazole";

import Atomoxetine from "./Atomoxetine/Atomoxetine";
import Dia_atomoxetine from "./Atomoxetine/Dia_atomoxetine";

import Atorvastatin from "./Atorvastatin/Atorvastatin";
import Dia_atorvastatin from "./Atorvastatin/Dia_atorvastatin";

import Azathioprine from "./Azathioprine/Azathioprine";
import Dia_azathioprine from "./Azathioprine/Dia_azathioprine";

import Brexipiprazole from "./Brexipiprazole/Brexipiprazole";
import Dia_brexipiprazole from "./Brexipiprazole/Dia_brexipiprazole";

import Capecitabine from "./Capecitabine/Capecitabine";
import Dia_capecitabine from "./Capecitabine/Dia_capecitabine";

import Carbamazepine from "./Carbamazepine/Carbamazepine";
import Dia_carbamezepine from "./Carbamazepine/Dia_carbamazepine";

import Codeine from "./Codeine/Codeine";
import Dia_codeine from "./Codeine/Dia_codeine";

import Eliglustat from "./Eliglustat/Eliglustat";
import Dia_eliglustat from "./Eliglustat/Dia_eliglustat";

import Dapsone from "./Dapsone/Dapsone";
import Dia_dapsone from "./Dapsone/Dia_dapsone";

import { useTheme } from "@mui/material";


export default function LowDrugs() {

const theme = useTheme();

return (
<>

{theme.palette.mode === "light" ? (

                <Grid container sx={{mb:2, p:1, pl:2, display:'flex', justifyContent:'center', bgcolor: 'grey.C600', borderRadius: '10px'}}>  
 
                        <Grid item xs={9} >  <Abacavir />   </Grid>
                        <Grid item xs={3} >  <Dia_abacavir />    </Grid> 
                        
                        <Grid item xs={9} >  <Allopurinol />   </Grid>
                        <Grid item xs={3} >  <Dia_allopurinol />    </Grid>
                        
                        <Grid item xs={9} >  <Amitriptyline />   </Grid>
                        <Grid item xs={3} >  <Dia_amitriptyline />    </Grid>
                        
                        <Grid item xs={9} >  <Aripiprazole />   </Grid>
                        <Grid item xs={3} >  <Dia_aripiprazole />    </Grid> 

                        <Grid item xs={9} >  <Atomoxetine />   </Grid>
                        <Grid item xs={3} >  <Dia_atomoxetine />    </Grid>

                        <Grid item xs={9} >  <Atorvastatin />   </Grid>
                        <Grid item xs={3} >  <Dia_atorvastatin />    </Grid>

                        <Grid item xs={9} >  <Azathioprine />   </Grid>
                        <Grid item xs={3} >  <Dia_azathioprine />    </Grid>

                        <Grid item xs={9} >  <Brexipiprazole />   </Grid>
                        <Grid item xs={3} >  <Dia_brexipiprazole />    </Grid>

                        <Grid item xs={9} >  <Capecitabine />   </Grid>
                        <Grid item xs={3} >  <Dia_capecitabine />    </Grid>

                        <Grid item xs={9} >  <Carbamazepine />   </Grid>
                        <Grid item xs={3} >  <Dia_carbamezepine />    </Grid>

                        <Grid item xs={9} >  <Codeine />   </Grid>
                        <Grid item xs={3} >  <Dia_codeine />    </Grid>

                        <Grid item xs={9} >  <Dapsone />   </Grid>
                        <Grid item xs={3} >  <Dia_dapsone />    </Grid>


                        <Grid item xs={9} >  <Eliglustat />   </Grid>
                        <Grid item xs={3} >  <Dia_eliglustat />    </Grid>

                        <Grid item xs={9} >  <Phenytoin />   </Grid>
                        <Grid item xs={3} >  <Dia_phenytoin />    </Grid>

                        <Grid item xs={9} >  <Rosuvastatin />   </Grid>
                        <Grid item xs={3} >  <Dia_rosuvastatin />    </Grid>
                        
                        <Grid item xs={9} >  <Statin />   </Grid>
                        <Grid item xs={3} >  <Dia_statin />    </Grid>

                </Grid>
  
) : (

        <Grid container sx={{mb:2, p:1, pl:2, display:'flex', justifyContent:'center', bgcolor: 'secondary.C800', borderRadius: '10px'}}>  
 
                <Grid item xs={9} >  <Abacavir />   </Grid>
                <Grid item xs={3} >  <Dia_abacavir />    </Grid> 
                
                <Grid item xs={9} >  <Allopurinol />   </Grid>
                <Grid item xs={3} >  <Dia_allopurinol />    </Grid>
                
                <Grid item xs={9} >  <Amitriptyline />   </Grid>
                <Grid item xs={3} >  <Dia_amitriptyline />    </Grid>
                
                <Grid item xs={9} >  <Aripiprazole />   </Grid>
                <Grid item xs={3} >  <Dia_aripiprazole />    </Grid> 

                <Grid item xs={9} >  <Atomoxetine />   </Grid>
                <Grid item xs={3} >  <Dia_atomoxetine />    </Grid>

                <Grid item xs={9} >  <Atorvastatin />   </Grid>
                <Grid item xs={3} >  <Dia_atorvastatin />    </Grid>

                <Grid item xs={9} >  <Azathioprine />   </Grid>
                <Grid item xs={3} >  <Dia_azathioprine />    </Grid>

                <Grid item xs={9} >  <Brexipiprazole />   </Grid>
                <Grid item xs={3} >  <Dia_brexipiprazole />    </Grid>

                <Grid item xs={9} >  <Capecitabine />   </Grid>
                <Grid item xs={3} >  <Dia_capecitabine />    </Grid>

                <Grid item xs={9} >  <Carbamazepine />   </Grid>
                <Grid item xs={3} >  <Dia_carbamezepine />    </Grid>

                <Grid item xs={9} >  <Codeine />   </Grid>
                <Grid item xs={3} >  <Dia_codeine />    </Grid>

                <Grid item xs={9} >  <Dapsone />   </Grid>
                <Grid item xs={3} >  <Dia_dapsone />    </Grid>


                <Grid item xs={9} >  <Eliglustat />   </Grid>
                <Grid item xs={3} >  <Dia_eliglustat />    </Grid>

                <Grid item xs={9} >  <Phenytoin />   </Grid>
                <Grid item xs={3} >  <Dia_phenytoin />    </Grid>

                <Grid item xs={9} >  <Rosuvastatin />   </Grid>
                <Grid item xs={3} >  <Dia_rosuvastatin />    </Grid>
                
                <Grid item xs={9} >  <Statin />   </Grid>
                <Grid item xs={3} >  <Dia_statin />    </Grid>

                </Grid>

)}

</>

)};
